import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { NodeSelection } from 'prosemirror-state';
import { ImageUploadProgressNodeWrapper } from './ImageUploadProgressNodeWrapper';

export const IMAGE_UPLOAD_PROGRESS_NODE_NAME = 'imageUploadProgress';

export const ImageUploadProgress = Node.create({
  name: IMAGE_UPLOAD_PROGRESS_NODE_NAME,
  group: 'block',
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      progress: {
        default: 0,
      },
    };
  },

  addCommands() {
    return {
      updateImageUploadProgress:
        (progress: number) =>
        ({ commands }) => {
          return commands.updateAttributes(this.name, { progress });
        },
      createImageUploadProgress:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              progress: 0,
            },
          });
        },
      selectImageUploadProgress:
        () =>
        ({ commands }) => {
          return commands.command(({ tr, state }) => {
            let position: number | null = null;

            state.doc.descendants((node, pos) => {
              if (node.type.name === this.name) {
                position = pos;
                return false;
              }
            });

            if (position === null) return false;

            const resolvedPos = tr.doc.resolve(position);
            const nodeSelection = new NodeSelection(resolvedPos);
            tr.setSelection(nodeSelection);

            return true;
          });
        },
      deleteImageUploadProgress:
        () =>
        ({ tr, state }) => {
          state.doc.descendants((node, pos) => {
            if (node.type.name === 'imageUploadProgress') {
              tr.delete(pos, pos + node.nodeSize);

              return false;
            }
          });

          return true;
        },
      hasImageUploadProgress:
        () =>
        ({ state }) => {
          let nodeExists = false;

          state.doc.descendants((node) => {
            if (node.type.name === this.name) {
              nodeExists = true;
              return false;
            }
          });

          return nodeExists;
        },
    };
  },

  parseHTML() {
    return [];
  },

  renderHTML() {
    return document.createTextNode('');
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageUploadProgressNodeWrapper);
  },
});
